import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
interface Options {
  label: string;
  value: string
}
@Component({
  selector: 'dp-dropdown',
  standalone: true,
  imports: [MatSelectModule, MatFormFieldModule],
  templateUrl: './dp-dropdown.component.html',
  styleUrl: './dp-dropdown.component.scss'
})
export class DpDropdownComponent {
  options!: Options[];
}
